import { lazy } from 'react';
import { CONTRACT_PERMISSIONS } from './constants';

const ContractListPage = lazy(() => import('./pages/ContractListPage'));
const ContractDetailPage = lazy(() => import('./pages/ContractDetailPage'));

export const contractRoutes = [
  {
    path: '/contracts',
    element: ContractListPage,
    permission: CONTRACT_PERMISSIONS.READ,
    nav: { labelKey: 'nav.contracts', icon: 'FileTextOutlined', group: 'commerce' },
  },
  {
    path: '/contracts/:contractNumber',
    element: ContractDetailPage,
    permission: CONTRACT_PERMISSIONS.READ,
    nav: null,
  },
];
